var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _a, _b;
import Tea from 'byted-tea-sdk';
import Wil from '@fe/wil';
var isExteralProd = location.host === 'arco.design';
var isInnerProp = location.host === "arco."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"";
if (isExteralProd || isInnerProp) {
  var extra = window.themeConfig ? {
    themeName: (_a = window.themeConfig) === null || _a === void 0 ? void 0 : _a.themeName,
    themeId: (_b = window.themeConfig) === null || _b === void 0 ? void 0 : _b.themeId
  } : {};
  Tea.init({
    app_id: isInnerProp ? 263440 : 290648,
    channel: 'cn',
    autotrack: {
      custom: 'tea'
    }
  });
  Tea.config({
    _staging_flag: isExteralProd || isInnerProp ? 0 : 1,
    evtParams: __assign({
      site: 'arco_themes' || 'ArcoDesign'
    }, extra)
  });
  Tea.start();
  Wil(function (logEvent) {
    if (logEvent.type === 'click') {
      Tea.beconEvent(logEvent.log['event'], logEvent.log);
    }
  });
}